import React from 'react';

/**
 * Line-art illustrations for the home launcher.
 *
 * Each one is a 64x64 line drawing that inherits colour from CSS:
 *   - strokes use `currentColor` (the tile sets it to the brand colour)
 *   - the soft fill uses `--art-fill`, so the shape still reads when the tile
 *     is dimmed for a "coming soon" module.
 */

const base = {
  viewBox: '0 0 64 64',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
};

const FILL = 'var(--art-fill)';

// Portfolio of buildings.
export const AssetsArt = (props) => (
  <svg {...base} {...props}>
    <rect x="6" y="26" width="16" height="30" rx="2" fill={FILL} />
    <rect x="24" y="14" width="18" height="42" rx="2" fill={FILL} />
    <rect x="44" y="32" width="14" height="24" rx="2" fill={FILL} />
    <path d="M6 56h52" />
    <path d="M11 33h6M11 40h6M11 47h6" />
    <path d="M29 21h8M29 29h8M29 37h8M29 45h8" />
    <path d="M48 39h6M48 46h6" />
  </svg>
);

// A single villa.
export const PropertiesArt = (props) => (
  <svg {...base} {...props}>
    <path d="M10 28 32 11l22 17" />
    <path d="M15 26v28h34V26" fill={FILL} />
    <path d="M8 54h48" />
    <path d="M27 54V38h10v16" />
    <rect x="19" y="31" width="7" height="7" rx="1" />
    <rect x="38" y="31" width="7" height="7" rx="1" />
  </svg>
);

// Contract sheet with a signature line.
export const ContractsArt = (props) => (
  <svg {...base} {...props}>
    <path d="M14 8h24l12 12v36a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2Z" fill={FILL} />
    <path d="M38 8v12h12" />
    <path d="M20 28h16M20 35h22M20 42h10" />
    <path d="M20 50c4-4 7 3 11-1s6 1 9-1" />
  </svg>
);

// Price tag — an offer.
export const OffersArt = (props) => (
  <svg {...base} {...props}>
    <path d="M33 7H12a5 5 0 0 0-5 5v21a4 4 0 0 0 1.2 2.8l22 22a4 4 0 0 0 5.6 0l19-19a4 4 0 0 0 0-5.6l-22-22A4 4 0 0 0 33 7Z" fill={FILL} />
    <circle cx="19" cy="19" r="4" />
    <path d="M28 38l10-10M31 45l12-12" />
  </svg>
);

// Clipboard of incoming requests.
export const RequestsArt = (props) => (
  <svg {...base} {...props}>
    <path d="M15 12h6V9a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v3h6a2 2 0 0 1 2 2v40a2 2 0 0 1-2 2H15a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2Z" fill={FILL} />
    <path d="M21 12h22" />
    <path d="M22 28l3 3 5-6M22 41l3 3 5-6" />
    <path d="M36 30h10M36 43h10" />
  </svg>
);

// Folder of office documents.
export const OfficeDocsArt = (props) => (
  <svg {...base} {...props}>
    <path d="M7 16a3 3 0 0 1 3-3h13l5 6h23a3 3 0 0 1 3 3v6H7v-12Z" fill={FILL} />
    <path d="M7 28h47v22a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V28Z" fill={FILL} />
    <path d="M22 38h20M22 45h13" />
  </svg>
);
